import React from 'react';
import { Heart, Sun, Eye } from 'lucide-react';
import SEO from '../components/SEO';
import './Practice.css';

const Practice = () => {
  const practices = [
    {
      icon: <Sun size={40} />,
      title: 'Daily Tuning',
      duration: '2 minutes',
      description: 'Notice breath/heartbeat; soften tension; choose one kind intention.',
      steps: [
        'Find a quiet moment',
        'Feel your breath and heartbeat',
        'Release physical tension',
        'Set one intention of kindness'
      ]
    },
    {
      icon: <Heart size={40} />,
      title: 'Acts of Resonance',
      duration: 'Throughout the day',
      description: 'Do one concrete kindness; reduce needless harm.',
      steps: [
        'Perform one deliberate act of kindness',
        'Choose compassion in interactions',
        'Minimize harm to others and the environment',
        'Notice the ripple effects of your actions'
      ]
    },
    {
      icon: <Eye size={40} />,
      title: 'Awe Moment',
      duration: 'Once daily',
      description: 'Learn or observe one true thing about nature/space each day.',
      steps: [
        'Observe something in nature',
        'Learn one scientific fact',
        'Contemplate the cosmos',
        'Feel your connection to the whole'
      ]
    }
  ];

  return (
    <div className="practice-page">
      <SEO
        title="Daily Practices"
        description="Simple daily practices for living in cosmic harmony: Daily tuning (2 minutes), acts of resonance, and awe moments. Lightweight spiritual practices without religion."
        keywords="daily spiritual practice, mindfulness practices, secular meditation, cosmic awareness, acts of kindness, awe practice, non-religious spiritual practices"
        canonicalUrl="/practice"
      />
      
      {/* Hero Section */}
      <section className="practice-hero cosmic-bg">
        <div className="container">
          <h1 className="heading-1 text-center">Daily Practice</h1>
          <p className="body-large text-center" style={{maxWidth: '700px', margin: '24px auto 0'}}>
            Lightweight practices to help you live in tune with the cosmic flow.
          </p>
        </div>
      </section>

      {/* Practices Section */}
      <section className="section-padding">
        <div className="container">
          <h2 className="heading-2 text-center mb-8">Three Simple Practices</h2>
          <div className="practices-grid">
            {practices.map((practice, index) => (
              <div key={index} className="practice-card card hover-lift">
                <div className="practice-icon text-gold">
                  {practice.icon}
                </div>
                <h3 className="heading-3">{practice.title}</h3>
                <div className="practice-duration">{practice.duration}</div>
                <p className="body-regular practice-description">{practice.description}</p>
                <ul className="practice-steps">
                  {practice.steps.map((step, stepIndex) => (
                    <li key={stepIndex} className="body-small">{step}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="section-padding-small cosmic-bg">
        <div className="container">
          <div className="community-section">
            <h2 className="heading-2 mb-4">Cosmergent Circles</h2>
            <p className="body-large">
              Simple gatherings for reflection, music, and scientific awe. Connect with others who see themselves as songs of the cosmos.
            </p>
          </div>
        </div>
      </section>

      {/* Integration Tips */}
      <section className="section-padding">
        <div className="container">
          <div className="integration-section">
            <h2 className="heading-2 text-center mb-4">Integrating Practice</h2>
            <div className="integration-content">
              <p className="body-large" style={{marginBottom: '24px'}}>
                These practices are not obligations—they are invitations. Start with what resonates, and let your practice evolve naturally.
              </p>
              <p className="body-large">
                The goal is not perfection, but gentle attunement to the greater harmony of existence.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Practice;